import React, { useState, useEffect } from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';
import { apiRequest } from '../../services/apiService';
import { Comodidade } from '../../data/Comodidades';

function ComodidadeForm() {
  const { id } = useParams<{ id: string }>();
  const [comodidade, setComodidade] = useState<Partial<Comodidade>>({
    nome: '',
    ativo: true,
  });
  const [loading, setLoading] = useState(!!id);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (id) {
      setLoading(true);
      apiRequest<Comodidade>(`comodidades/${id}`, 'GET', true)
        .then(data => {
          setComodidade(data);
        })
        .catch(err => setError((err as Error).message || 'Erro ao carregar a comodidade.'))
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, [id]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, type, checked } = e.target;
    setComodidade(prevComodidade => ({
      ...prevComodidade,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      await apiRequest('comodidades', 'POST', true, comodidade);
      navigate('/comodidades');
    } catch (err) {
      setError((err as Error).message || 'Erro ao salvar a comodidade.');
    } finally {
      setLoading(false);
    }
  };

  if (loading && id) {
    return <p>Carregando...</p>;
  }

  return (
    <div className="row">
      <div className="card">
        <div className="card-body">
          <div className="mb-3">
            <h1 className="h3 d-inline align-middle">{id ? 'Editar Comodidade' : 'Nova Comodidade'}</h1>
          </div>
          {error && <div className="alert alert-danger">Erro: {error}</div>}
          <form onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-md-8 mb-3">
                <label htmlFor="nome" className="form-label">Nome</label>
                <input type="text" id="nome" name="nome" className="form-control" value={comodidade.nome || ''} onChange={handleChange} required />
              </div>
            </div>

            <div className="mb-3 form-check">
              <input type="checkbox" id="ativo" name="ativo" className="form-check-input" checked={!!comodidade.ativo} onChange={handleChange} />
              <label htmlFor="ativo" className="form-check-label">Ativo</label>
            </div>

            <hr />

            <button type="submit" disabled={loading} className="btn btn-primary me-2">
              {loading ? 'Salvando...' : (id ? 'Atualizar' : 'Salvar')}
            </button>
            <Link to="/comodidades" className="btn btn-secondary">Cancelar</Link>
          </form>
        </div>
      </div>
    </div>
 );
}

export default ComodidadeForm;